import { EDITAR_DEVOLUCAO } from "constants/ActionTypes";
import { SET_REQUEST } from "constants/ActionTypes";

const INIT_STATE = {
    devolucao: {},
    devolucaoEdit: false,
    request: {},
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EDITAR_DEVOLUCAO: {
            return {
                ...state,
                devolucao: action.payload.data,
                devolucaoEdit: true,
            };
        }

        case SET_REQUEST: {
            return {
                ...state,
                request: action.payload.data,
            };
        }

        default:
            return state;
    }
};
